import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeftFill = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 5.414c0-.89-1.076-1.337-1.706-.707L5.708 7.293a1 1 0 0 0 0 1.414l2.586 2.586c.63.63 1.707.184 1.707-.707V5.414Z" }));
const ForwardRef = forwardRef(SvgChevronLeftFill);
export default ForwardRef;
